<template>
 <div class="summary-dialog">
	<el-dialog :title="summaryTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" :before-close="close">
        <pt-form-item label="中文名称" :label-width="formLabelWidth">
          <el-input v-model="topNode.name" auto-complete="off"></el-input>
        </pt-form-item>
        <pt-form-item label="英文名称" :label-width="formLabelWidth">
          <el-input v-model="topNode.englishName" auto-complete="off"></el-input>
        </pt-form-item>
        <pt-form-item label="类型" :label-width="formLabelWidth">
          <detection-category-selector v-model="topNode.detectionItemCategory"></detection-category-selector>
        </pt-form-item>
        <pt-form-item label="是否为概述分类" :label-width="formLabelWidth">
          <el-radio-group v-model="topNode.summary">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </pt-form-item>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" v-intervalclick="{func:certain,time:500}">确 定</el-button>
      </div>
    </el-dialog>
 </div>
</template>

<script>
import detectionCategorySelector from 'cps/gene-product/selector/detection-category-selector'
export default {
  name: 'package-dialog',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    summaryTitle: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      topNode: JSON.stringify(this.form) !== '{}' ? this.form : {},
      formLabelWidth: '130px'
    }
  },
  components: {
    detectionCategorySelector
  },
  watch: {
    form (val) {
      this.topNode = val
    }
    // 'topNode': {
    //   handler: function (newVal) {
    //     // // console.log('---xin',newVal)
    //     // this.catForm = newVal
    //     this.$emit()
    //   },
    //   deep: true
    // }
  },
  methods: {
    close () {
      this.topNode = {}
      this.$emit('update', false)
    },
    certain () {
      this.topNode.type = 'CATEGORY'
      if (this.isEdit) {
        this.$emit('updateSummary', this.topNode)
      } else {
        this.$emit('addSummary', this.topNode)
      }

      this.close()
    }
  },
  created () {
    // console.log('creaetd', this.categoryForm)
  }
}
</script>

<style lang="less">
.package-dialog{
  .el-dialog{
    min-width: 600px;
  }
}
</style>
